import React from "react";
import Error from "../elements/404"
import Footer from "../elements/Footer";

function NotFound() {
    return (
      
        <div className="404">
            <Error />
            <Footer />
        
        </div>
    
  );
}

export default NotFound;
